@import (reference) '../../../constants/spacing.module.less';

.container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 100%;
  height: 100%;
}

.child-container {
  position: relative;
}

.decoration-container {
  position: absolute;
  top: 0;
  right: 0;
}
